import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import { cn } from '@repo/utils'

import styles from './index.css'

class ProgressBar extends PureComponent {
  getValue = () => Math.min(Math.max(this.props.value, 0), 100)

  render() {
    const { alert, ariaLabel, className, inverted, tabIndex } = this.props
    const value = this.getValue()
    const hiddenPercentage = `${100 - value}%`

    return (
      <div
        aria-label={ariaLabel}
        aria-valuemax={100}
        aria-valuemin={0}
        aria-valuenow={value}
        className={cn(
          className,
          styles.wrapper,
          alert && styles.alert,
          inverted && styles.inverted,
          value === 100 && styles.complete,
        )}
        role="progressbar"
        tabIndex={tabIndex}
        title={ariaLabel}
      >
        <div className={styles.bar} style={{ width: hiddenPercentage }} />
      </div>
    )
  }
}

ProgressBar.propTypes = {
  value: PropTypes.number.isRequired,

  alert: PropTypes.bool,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  inverted: PropTypes.bool,
  tabIndex: PropTypes.number,
}

ProgressBar.defaultProps = {
  alert: false,
  ariaLabel: null,
  className: '',
  inverted: false,
  tabIndex: 0,
}

export default ProgressBar
